import md5 from 'md5'

import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import {
  ChangeUsuarioPasswordParams,
  ChangeUsuarioPasswordResponse,
  CreateUsuarioParams,
  CreateUsuarioResponse,
  EditUsuarioParams,
  EditUsuarioResponse,
  FindUsuarioByIdParams,
  FindUsuarioByIdResponse,
  ResetUsuarioPasswordParams,
  ResetUsuarioPasswordResponse,
  SearchUsuariosParams,
  SearchUsuariosResponse,
} from '../domain/usuario'

const ROOT_URL = '/core/users'

export const UsuarioService = {
  search: async (params: SearchUsuariosParams) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<SearchUsuariosResponse>(url)
  },

  findById: async ({ userId }: FindUsuarioByIdParams) => {
    const url = ROOT_URL + `/${userId}`
    return await WitaConnector.get<FindUsuarioByIdResponse>(url)
  },

  create: async (params: CreateUsuarioParams) => {
    const url = ROOT_URL
    return await WitaConnector.post<CreateUsuarioResponse>(url, params)
  },

  edit: async ({ id, ...params }: EditUsuarioParams) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<EditUsuarioResponse>(url, params)
  },

  resetPassword: async ({ id }: ResetUsuarioPasswordParams) => {
    const url = ROOT_URL + `/${id}/password-reset`
    return await WitaConnector.put<ResetUsuarioPasswordResponse>(url, null)
  },

  changePassword: async ({ id, ...params }: ChangeUsuarioPasswordParams) => {
    const url = ROOT_URL + `/${id}/password-change`
    const data = { password: md5(params.password) }
    return await WitaConnector.put<ChangeUsuarioPasswordResponse>(url, data)
  },
}
